import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "blog-post-area ptb-100 text-center text-silver"
}
const _hoisted_2 = {
  key: 1,
  class: "blog-post-area ptb-100 text-center text-silver"
}
const _hoisted_3 = { class: "blog-post-hero-overlay" }
const _hoisted_4 = { class: "container mw-1356" }
const _hoisted_5 = { class: "blog-post-hero-inner" }
const _hoisted_6 = { class: "blog-post-date" }
const _hoisted_7 = { class: "blog-post-title" }
const _hoisted_8 = {
  key: 0,
  class: "blog-post-excerpt"
}
const _hoisted_9 = { class: "blog-post-area" }
const _hoisted_10 = { class: "container mw-900" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "blog-post-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading... "))
      : (!_ctx.post)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Post not found. "))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", {
              class: "blog-post-hero",
              style: _normalizeStyle(_ctx.post.cover_image ? { backgroundImage: `url(${_ctx.post.cover_image})` } : {})
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.post.published_at)), 1),
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.post.title), 1),
                    (_ctx.post.excerpt)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.post.excerpt), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 4),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "blog-content",
                  innerHTML: _ctx.renderedContent
                }, null, 8, _hoisted_11),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_RouterLink, {
                    to: "/blog",
                    class: "btn"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("span", { class: "border-style" }, [
                        _createElementVNode("i", { class: "ti ti-arrow-left" }),
                        _createTextVNode(" Back to Blog")
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_RouterLink, {
                    to: "/pricing",
                    class: "btn ms-2"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("span", { class: "border-style" }, "Get IPTV Access", -1)
                    ])),
                    _: 1
                  })
                ])
              ])
            ])
          ], 64)),
    _createVNode(_component_MainFooter)
  ]))
}